import React from "react";
import "./headline.module.css";

export const Headline = ({ content }) => {
  return <h1 styleName="headline" dangerouslySetInnerHTML={{ __html: content }} />;
};
